const NAMES = { gmgn: "GMGN", axiom: "Axiom", fomo: "FOMO", birdeye: "Birdeye" };

export const SourceBadges = ({ status = {} }) => (
  <div className="flex flex-wrap gap-1.5" data-testid="source-badges">
    {["gmgn", "axiom", "fomo", ...Object.keys(status).filter((k) => !["gmgn", "axiom", "fomo"].includes(k))].map((k) => {
      const s = status[k];
      const off = s && !s.ok && (s.error || "").startsWith("not connected");
      const tone = !s || off ? "border-slate-600 text-slate-500" : s.ok ? "border-[#14F195]/50 text-[#14F195]" : "border-[#F59E0B]/50 text-[#F59E0B]";
      const label = !s ? "pending" : s.ok ? `${s.count} live` : off ? "not connected" : "error";
      return (
        <span key={k} title={s?.error || ""} data-testid={`source-badge-${k}`}
          className={`px-2 py-0.5 border text-[10px] font-mono uppercase tracking-wider transition-colors ${tone}`}>
          {s?.ok ? "●" : "○"} {NAMES[k] || k} · {label}
        </span>
      );
    })}
  </div>
);
